import React from "react";
import { Header } from "./Header";
export const AboutMe = () => {
  return <Header />;
};
